import builder from '../builder';
import AlertCircle from '../../streamline-icons/bold/alert-circle.svg';

export default builder('IconAlertCircleBold', AlertCircle);
